import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import { Box, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Text } from "@src/appV2/redesign/components/Text";
import { type Agent } from "@src/appV2/User/api/useSearchAgents";
import { forwardRef } from "react";

interface AgentResultItemProps {
  agent: Agent;
  selected: boolean;
  expanded: boolean;
  isLoadingShifts: boolean;
  onClick: () => void;
}

export const AgentResultItem = forwardRef<HTMLDivElement, AgentResultItemProps>((props, ref) => {
  const { agent, selected, expanded, isLoadingShifts, onClick } = props;

  return (
    <ListItemButton
      ref={ref}
      selected={selected}
      sx={{
        py: 1,
        px: 2,
        "&.Mui-selected": {
          backgroundColor: "action.selected",
        },
      }}
      onClick={onClick}
    >
      <ListItemIcon sx={{ minWidth: 40 }}>
        <PersonIcon color="primary" />
      </ListItemIcon>
      <ListItemText
        primary={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Text sx={{ fontWeight: 500 }}>{agent.name}</Text>
            {selected &&
              (expanded ? (
                <ExpandMoreIcon fontSize="small" />
              ) : (
                <ChevronRightIcon fontSize="small" />
              ))}
            {isLoadingShifts && expanded && <CircularProgress size={14} />}
          </Box>
        }
        secondary={agent.email}
        secondaryTypographyProps={{ variant: "caption" }}
      />
    </ListItemButton>
  );
});

AgentResultItem.displayName = "AgentResultItem";
